
import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";

import { LOAN_SECTION_KEYS } from "../loan.constants";

export class LoanQuoteHistory extends Component {
  render() {
    const { data, history, loanId, enableEditButton, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Quote History",
            key: LOAN_SECTION_KEYS.QUOTE_HISTORY,
            isTitleGroup: true
          },
          {
            key: LOAN_SECTION_KEYS.VIEW_QUOTE_HISTORY,
            buttonLabel: "View Quote History",
            showEditButton: enableEditButton,
            isButton: true,
            onClick: () => history.push(`/quoteHistory/${loanId}`)
          }
        ]}
      />
    );
  }
}
